import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import FiltersMenuContentQuery, {
	type JiraWorkManagementFilterSearchInput,
} from '@atlassian/jira-relay/src/__generated__/FiltersMenuContentQuery.graphql';

export const filtersMenuEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-issue-navigator-filters-menu-entrypoint" */ './FiltersMenuContent.tsx'
			),
	),
	getPreloadProps: ({
		searchParameters,
		first,
	}: {
		searchParameters: JiraWorkManagementFilterSearchInput;
		first?: number;
	}) => ({
		queries: {
			mainQuery: {
				parameters: FiltersMenuContentQuery,
				variables: {
					searchParameters,
					first,
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
	}),
});
